import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { diffAndCommon } from "../../../../services/util";
import { UpdateEventDetails } from "../../../../revampCRUD/commonAPIs.crud";
import { getEventDetails } from "../../../../revampCRUD/eventDetails.crud";
import customToast from "../../../../components/common/basic/Toast";
import FormButtons from "../../../../revampComponents/Molecule/Buttons/FormButtons";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import validationSchema from "./Validation";
import { regexMethods } from "../../../../reusable/common";
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import PostRegistration from "../../../EventInfo/Tickets/TicketSettings/PostRegistration";

const WebsiteIntegrations = ({ eventInfo, isRestricted = false }) => {
	const [loading, setLoading] = useState(false);
	const [loadPage, setLoadPage] = useState(false);
	const [initialValues, setInitialValues] = useState({
		// remove_kh_branding: false,
		redirection_url: eventInfo.redirection_url,
		redirection_url_timeout: eventInfo.redirection_url_timeout
	});
	const [postRegModal, setPostRegModal] = useState(false);
	const [eventDetails, setEventDetails] = useState({});

	const validate = async values => {
		let errors = {};
		errors = await validationSchema(values);
		return errors;
	};

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: initialValues,
		validateOnBlur: true,
		validateOnChange: true,
		validate: validate,
		onSubmit: async values => {
			setLoading(true);
			const updated_details = diffAndCommon("diff", [values, initialValues], []);

			if (
				updated_details.hasOwnProperty("redirection_url") &&
				updated_details.redirection_url == ""
			) {
				updated_details.redirection_url = null;
			}

			if (
				updated_details.hasOwnProperty("redirection_url_timeout") &&
				updated_details.redirection_url_timeout == ""
			) {
				updated_details.redirection_url_timeout = 0;
			}

			await UpdateEventDetails(updated_details, eventInfo.event_id)
				.then(({ data }) => {
					if (data == "OK") {
						customToast.success("Saved successfully!");
						getEventDetailsFunction(eventInfo.event_id);
					} else {
						customToast.error("Something went wrong");
					}
				})
				.catch(err => {
					const error = err?.response?.data?.error || "Something went wrong";
					customToast.error(error);
				});
			setLoading(false);
		}
	});

	const getEventDetailsFunction = async eventId => {
		setLoadPage(true);
		const Data = await getEventDetails(eventId);
		if (Data.status == 200) {
			setEventDetails(Data.data);
			setInitialValues({
				redirection_url: Data.data.redirection_url,
				redirection_url_timeout: Data.data.redirection_url_timeout
			});
			setLoadPage(false);
		}
	};

	useEffect(() => {
		getEventDetailsFunction(eventInfo.event_id);
	}, []);

	const openPostRegModalFunc = () => {
		setPostRegModal(true);
	};

	const getEventDetailsCallBackFunc = () => {
		getEventDetailsFunction(eventInfo.event_id);
	};

	return (
		<>
			{loadPage ? (
				<LoadingSpinner />
			) : (
				<>
					<div className="row">
						<div className="col-md-12">
							<label className="label mb-0">Custom Redirection</label>
							<p className="mt-2 mb-0 description-text">
								Provide custom page url to redirect attendees after registration.
							</p>
							<p className="mb-0 description-text">
								(<b>Note:</b> If you set up custom redirection, face detection
								option will not be visible for the participants)
							</p>
							<input
								name="redirection_url"
								id="redirection_url"
								disabled={isRestricted}
								className={
									formik.errors["redirection_url"] &&
										formik.touched.sponsor_section_title
										? "input border-danger box-shawdow-none mt-2"
										: "input mt-2"
								}
								placeholder="Enter redirection URL"
								onBlur={formik.handleBlur}
								value={formik.values.redirection_url}
								onChange={formik.handleChange}
							/>
							{formik.errors.redirection_url && formik.touched.redirection_url && (
								<p className="text-danger mb-1">{formik.errors.redirection_url}</p>
							)}
							<p className="mb-0 mt-2 description-text">
								The text on the redirection modal can be configured from{" "}
								<span className={`modal-open-link ${isRestricted ? "event-template-button" : ""} `} onClick={openPostRegModalFunc}>
									Post Registration Message
								</span>
								.
							</p>
						</div>
						<div className="col-md-12 mt-3">
							<label className="label mb-0">Popup Timer (in seconds)</label>
							<div className="d-flex justify-content-between align-items-center">
								<p>
									<p className="mt-2 description-text mb-0">
										Specify the duration for which the success popup will remain
										visible to participants, allowing them to download their
										tickets and invoices.
									</p>
									<p className="description-text">
										(<b>Note:</b> If value is 0 then the success popup will not
										be displayed to participants)
									</p>
								</p>
								<input
									type="number"
									className="input"
									disabled={isRestricted}
									style={{ width: "113px" }}
									name="redirection_url_timeout"
									id="redirection_url_timeout"
									min="0"
									onKeyPress={e => regexMethods.allowOnlyPositiveNumber(e)}
									value={formik.values.redirection_url_timeout}
									onChange={formik.handleChange}
								/>
							</div>
						</div>
					</div>
					{!isRestricted && (
						<div>
							<FormButtons
								onSave={formik.handleSubmit}
								onCancel={() => formik.resetForm()}
								saveBtnContent={"Save"}
								cancelBtnDisabled={false}
								isLoading={loading}
								saveBtnDisabled={loading || !formik.dirty}
							/>
						</div>
					)}
					<CustomModal
						openModal={postRegModal}
						setOpenModal={setPostRegModal}
						saveBtnContent={null}
						header={null}
						floatingButton={null}
						floatingCancelButton="Close"
						overflow="auto"
						content={
							<div className="d-flex flex-column justify-content-center mx-2">
								<div className="primary-color text-left post-reg-heading mb-3">
									Post Registration Message
								</div>
								<PostRegistration
									eventDetails={eventDetails}
									className="m-0"
									whiteLabel={true}
									setPostRegModal={setPostRegModal}
									getEventDetailsCallBackFunc={getEventDetailsCallBackFunc}
								></PostRegistration>
							</div>
						}
					/>
				</>
			)}
			<style jsx>
				{`
					.description-text {
						font-family: Hind;
						font-size: 14px;
						font-weight: 400;
						line-height: 22.41px;
						color: #6d7780;
					}
					.modal-open-link {
						color: #007bff;
						text-decoration: underline;
						cursor: pointer;
					}
					.post-reg-heading {
						font-size: 16px;
						font-weight: 500;
					}
					.event-template-button {
                        pointer-events: none;
					    opacity: 0.6;
                    }
				`}
			</style>
		</>
	);
};

export default WebsiteIntegrations;
